import {RiCloseFill} from 'react-icons/ri';

import {Button} from '../button';
import {DialogClose} from '../dialog';

export default function GenericDialog({
	heading,
	children,
}: {
	heading: string;
	children: React.ReactNode;
}) {
	return (
		<div className="relative bg-white">
			<h2 className="p-5 text-lg font-semibold">{heading}</h2>
			<div className="h-full bg-white px-5 pb-5">{children}</div>
			<div className="sticky bottom-0 flex w-full gap-2 border-t border-gray-200 bg-white p-4 shadow-custom-up">
				<DialogClose asChild>
					<Button className="border-2 border-text-secondary bg-white px-4 py-2 text-black hover:border-[#DD2A2E] hover:bg-white hover:text-red-600">
						{' '}
						<RiCloseFill className="size-6" /> Lukk
					</Button>
				</DialogClose>
			</div>
		</div>
	);
}
